import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { PlantType, VariantType, CurrentTeamType, PitchType, Flag,
         Version, LineTeam, SelectTeam, ModelVariant } from '../../shared/models/type-list';

@Injectable({
  providedIn: 'root'
})
export class TeamService extends AbstractRestService {

  public line_team$ = new BehaviorSubject<LineTeam>(null)
  public version$ = new BehaviorSubject<Version>(null)
  public team_id$ = new BehaviorSubject<number>(null)
  //When excute the pitch transfer operation should a refresh of team work
  public workPitchRefresh$ = new BehaviorSubject<boolean>(false)

  private currentTeamData: CurrentTeamType
  postInit(): void{}

 
  plantList(): Observable<GenericLambdaReturn<PlantType[]>>{
    console.log(' using plantType  ')
    return this.get({
      ApiResource: "/config",
      repeatCall: false
    });
  }

  getTeams(plant_name: string, line_name: string, subline_name: string): Observable<GenericLambdaReturn<LineTeam[]>>{

    let params:any = {}

    params.PlantName = plant_name

    if (line_name != '') {
      params.Line = line_name
    }

    params.Subline = subline_name

    return this.get({
      ApiResource: "/team",
      data: params,
      repeatCall: false
    });
  }

  getPitches(team_id: number, version_id: number): Observable<GenericLambdaReturn<PitchType[]>>{
    console.log(' Using pitch type ')

    let params: any = {}

    params.TeamID = team_id
    params.VersionID = version_id

    return this.get({
      ApiResource: "/pitch",
      data: params,
      repeatCall: false
    });
  }

  createPitch(plant_name:string,team_id:number,version_id:number,pitch_id:string,pitch_type:string,subassembly_id:string,takt_time:number,pitch_status:string,
    variantIDs:number[],pitchName: string, service_attribute: string, service_color: string, cover_team?: number, materials?: string, variant_detail?: any[]):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};
    console.log('Service: Create Pitch: ', variant_detail)

    params.PlantName = plant_name;
    params.PitchID = pitch_id;
    params.TeamID = team_id; 
    params.VersionID = version_id;
    params.PitchType = pitch_type;
    params.SubassemblyID = subassembly_id;
    params.TaktTime = takt_time;
    params.PitchStatus = pitch_status;
    params.VariantIDs = variantIDs;
    params.PreviouspitchID = pitch_id;
    params.PrevioussubassemblyId = subassembly_id;
    params.PitchName = pitchName;
    params.ServiceAttribute = service_attribute;
    params.ServiceColor = service_color;
    params.CoverTeam = cover_team;
    if (materials != undefined)
      params.Materials = materials;
    if (variant_detail != undefined)
      params.VariantDetail = variant_detail;

    return this.post({
      ApiStage: "StandardWork",
      ApiResource: "/pitch",
      data: {
        data: params
      }
    });
  }

  updatePitch(plant_name:string, team_id:number, version_id:number, pitch_config_id:number, pitch_id:string, pitch_type:string, subassembly_id:string, 
    takt_time:number, pitch_status:string, variantIDs:number[], pitchName: string, ergoScore: number, ergoComments : string, service_attribute?:string, 
    service_color?: string, cover_team?:number, materials?:string, variant_detail?: any[]) : Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};
    
    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchConfigID = pitch_config_id;
    params.PitchID = pitch_id;
    params.PitchType = pitch_type;
    params.SubassemblyID = subassembly_id;
    params.TaktTime = takt_time;
    params.PitchStatus = pitch_status;
    params.VariantIDs = variantIDs;
    params.PitchName = pitchName;
    params.ErgoScore = ergoScore;
    params.ErgoComments = ergoComments;
    if (service_attribute != undefined)
      params.ServiceAttribute = service_attribute;
    if (service_color != undefined)
      params.ServiceColor = service_color;
    if (cover_team != undefined)
      params.CoverTeam = cover_team;
    if (materials != undefined)
      params.Materials = materials;  
    if (variant_detail != undefined)
      params.VariantDetail = variant_detail;


    return this.post({
      ApiStage: "StandardWork",
      ApiResource: "/pitch",
      data: {
        data: params
      }
    });
  }

  deletePitch(pitch_config_id:number,plant_name:string,team_id:number,version_id:number,pitch_id:string):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};

    params.PitchConfigID = pitch_config_id;
    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchID = pitch_id;

    return this.delete({
      ApiResource: "/pitch",
      data: params
    });
  }

  copyPitchWork(plant_name:string, copy_pitch: number, update_pitch: number):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};
    
    params.PlantName = plant_name;
    params.CopyPitch = copy_pitch;
    params.UpdatePitch = update_pitch;
    
    return this.post({
      ApiResource: "/pitch/copy",
      data: {data: params},
      repeatCall: false
    });
  }

  transferPitchWork(plant_name:string, team_id: number, version_id: number, from_pitch: number, from_variant_id: number, to_pitch: number, to_variant_id: number):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};
    
    params.PlantName    = plant_name;
    params.TeamID       = team_id;
    params.VersionID    = version_id;
    params.FromPitch    = from_pitch;
    params.ToPitch      = to_pitch
    params.FromVariant  = from_variant_id;
    params.ToVariant    = to_variant_id;
    
    return this.post({
      ApiStage: "StandardWork",
      ApiResource: "/pitch/copy",
      data: {data: params},
      repeatCall: false
    });
  }

  getFlags():Observable<GenericLambdaReturn<Flag[]>>{

    let params: any = {}

    return this.get({
      ApiResource: "/flag",
      data: params,
      repeatCall: false
    });
  }

  getSelectedTeamData(): CurrentTeamType{
    return this.currentTeamData
  }

  createPitchFlag(pitch_config_id: number, flags: string[], plant_name:string, team_id: number, version_id: number, pitch_id: string){
    let params: any = {};

    params.PlantName = plant_name;
    params.PitchConfigID = pitch_config_id; 
    params.Flags = flags;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchID = pitch_id;

    return this.post({
      ApiStage: "StandardWork",
      ApiResource: "/pitch/flag",
      data: {
        data: params
      }
    });
  }

  deletePitchFlag(pitch_config_id: number, flag: string, plant_name:string, team_id: number, version_id: number, pitch_id: string){
    let params: any = {};
    params.PlantName = plant_name;
    params.PitchConfigID = pitch_config_id; 
    params.Flag = flag;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchID = pitch_id;

    return this.delete({
      ApiStage: "StandardWork",
      ApiResource: "/pitch/flag",
      data: params
    })
  }
  
  getVersions(team_id: number): Observable<GenericLambdaReturn<Version[]>>{

    let params:any = {}

    params.TeamID = team_id

    return this.get({
      ApiResource: "/version",
      data: params,
      repeatCall: false
    });
  }

  getTeamsWithVersions(plant_name: string, line_name: string, subline_name: string, include_version?: string, include_multiteam?: string, p0?: string): Observable<GenericLambdaReturn<SelectTeam[]>>{

    let params:any = {}

    params.PlantName = plant_name

    if (line_name != '') {
      params.Line = line_name
    }

    if (subline_name != '') {
      params.Subline = subline_name
    }

    if (include_version != undefined && include_version == 'true'){
      params.IncludeVersion = include_version
    }

    if (include_multiteam != undefined && include_multiteam == 'true'){
      params.IncludeMultiTeam = include_multiteam
    }

    return this.get({
      ApiResource: "/team",
      data: params,
      repeatCall: false
    });
  }

  getTeamVariant(team_id: number, version_id?: number):Observable<GenericLambdaReturn<VariantType[]>>{
    //returns a list of team variants and their associated model_variants
    let params: any = {};
    params.TeamID = team_id;
    if (version_id != undefined){
      params.VersionID = version_id;
    };

    return this.get({
        ApiStage: "StandardWork",
        ApiResource: "/variant",
        data: params,
        repeatCall: false
    });
  }

  getModelVariant(team_id: number):Observable<GenericLambdaReturn<ModelVariant[]>>{
    //returns a list of model variants and their associated team_variants
    console.log('Get Model Variant')
    let params: any = {}

    params.TeamID = team_id

    return this.get({
      ApiStage: "StandardWork",
      ApiResource: "/variant/model",
      data: params,
      repeatCall: false
    });
  }

  createTeamVariant(team_id: number, variant_name: string, model_ids: any[]):Observable<GenericLambdaReturn<any>>{

    let params: any = {};

    params.TeamID = team_id;
    params.VariantName = variant_name;
    params.ModelIDs = model_ids;

    console.log('POST parameters: ', params)
    let data_param = { data: params};

     return this.post({
      ApiStage: "StandardWork",
      ApiResource: "/variant",
      data: data_param
    });

  }

  compareStandardizedWork(plant_name: string, team_id: number, version_id: string):Observable<GenericLambdaReturn<any>>{
    //returns a list of model variants and their associated team_variants
    console.log('Compare Yamazumi with Standardized Work: Team ', team_id, ' Version ', version_id)
    let params: any = {}

    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;

    return this.get({
      ApiResource: "/standardwork/compare",
      data: params,
      repeatCall: false
    });
  }

  updateStandardizedWork(plant_name: string, team_id: number, version_id: string, pitch_variant_list:any):Observable<GenericLambdaReturn<any>> {
    let params: any = {};

    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchVariants = pitch_variant_list


    return this.post({
      ApiResource: "/standardwork",
      data: {
        data: params
      }
    })
  }

  deletePitchVariant(pitch_config_id:number,variant_id:number,plant_name:string,team_id:number,version_id:number,pitch_id:string,variant_name:string):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};

    params.PitchConfigID = pitch_config_id;
    params.VariantID = variant_id;
    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.PitchID = pitch_id;
    params.VariantName = variant_name;

    return this.delete({
      ApiStage: "StandardWork",
      ApiResource: "/pitch/variant",
      data: params
    });
  }

  updateTeamVariantName(team_id: number, variant_id: number, variant_name: string):Observable<GenericLambdaReturn<any>> {
    let params: any = {};

    params.TeamID = team_id;
    params.VariantID = variant_id;
    params.VariantName = variant_name;    

    return this.post({
      ApiStage: "StandardWork",
      ApiResource:"/variant",
      data: { data: params },
      repeatCall: false
    });
    
  }

  getTeamsByLine(plant_name: string, line_name: string): Observable<GenericLambdaReturn<LineTeam[]>>{

    let params:any = {}

    params.PlantName = plant_name
    params.Line = line_name
    
    return this.get({
      ApiStage: "StandardWork",
      ApiResource: "/team",
      data: params,
      repeatCall: false
    });
  }
    
}